import {httpClient} from '../../common/api/HttpClient';

export const slopeApi = {
    findById: (slopeId) => httpClient.get(`slopes/?slopeId=${slopeId}`),
    findAll: () => httpClient.get(`slopes/`),
    findAllLocations: () => httpClient.get(`slopes/locations`),
    findSlopesByLocation: (locationName) => httpClient.get(`slopes/location?locationName=${locationName}`),
    findSlopesByClubId: (clubId) => httpClient.get(`slopes/club?clubId=${clubId}`),
    createSlope: (slopeName) => httpClient.post(`slopes/?name=${slopeName}`, slopeName),
    updateSlope: (slope) => httpClient.put(`slopes/`, slope),
    deleteSlopeById: (slopeId) => httpClient.delete(`slopes/${slopeId}`),
    deleteLocationByName: (locationName) => httpClient.delete(`slopes/location/${locationName}`)
};

export default slopeApi;
